/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Link from '../../components/Link';
import GrayPanel from '../../components/GrayPanel';
import s from './Login.css';
import Modal from 'react-bootstrap/lib/Modal';
import PzIcon from './pz_logo.svg';
import logoPZ from './logoPZ.jpg';
import napisPZ from './napisPZ.jpg';
import waiting from './waiting-wheel-300x300.gif';
const isBrowser = typeof window !== 'undefined' && window !== null;

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
<Modal {...props}>
  <Modal.Header className="bg-warning" closeButton>
    <Modal.Title>{title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {bodyText}
    <br /><br />
    {!disableButton ? (
      <button className="btn btn-warning pull-right" onClick={() => props.onHide(name)}>Zamknij</button>
    ) : null}
    <br /><br />
  </Modal.Body>
</Modal>;

class Login extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      userValid: null,
      isMounted: false,
      passValid: null,
      didIlogedIn: Object.keys(this.props.query).indexOf('loginFailed') >= 0 ? true : false,
    };
  }

  componentDidMount = () => this.setState({ isMounted: true });

  userValidator = (e) => {
    // const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // this.setState({ emailValid: emailRegex.test(email) });
    if (e.target.value.length <= 0 || e.target.value == null) {
      this.setState({ userValid: false });
    } else {
      this.setState({ userValid: true });
    }
  }
  passValidator = (e) => {
    if (e.target.value.length <= 0 || e.target.value == null) {
      this.setState({ passValid: false });
    } else {
      this.setState({ passValid: true });
    }
  }
  onClickValid = () => {
    if (!this.state.userValid) {
      this.setState({ userValid: false });
    } else {
      this.setState({ userValid: true });
    }
    if (!this.state.passValid) {
      this.setState({ passValid: false });
    } else {
      this.setState({ passValid: true });
    }
  }

  hideModal = () => {
    this.setState({ didIlogedIn: false });
  }

  render() {
    const buttonType = (this.state.userValid === true && this.state.passValid === true) ? 'submit' : 'button';
    return (
      <div className={s.root}>
      {this.state.isMounted ?
        <div className={s.container}>
          <h1>{this.props.title}</h1>
          <form method="post">
            <div className={s.formGroup}>
              <label className={s.label} htmlFor="username">
                Nazwa użytkownika lub email:
              </label>

              <input
                className={s.input}
                id="username"
                type="text"
                name="username"
                onBlur={(e) => this.userValidator(e)}
                onChange={(e) => this.userValidator(e)}
                autoFocus
              />
            </div>
            {this.state.userValid === false ? <div style={{ color: 'red' }} className={s.formGroup}>
              Wprowadź nazwę użytkownika lub adres email!
            </div> : null }
            <div className={s.formGroup}>
              <label className={s.label} htmlFor="password">
                Hasło:
              </label>
              <input
                className={s.input}
                id="password"
                type="password"
                name="password"
                onBlur={(e) => this.passValidator(e)}
                onChange={(e) => this.passValidator(e)}
              />
              <Link to={'/resetPassword'}>Zapomniałeś hasła?</Link>
            </div>

            {this.state.passValid === false ? <div style={{ color: 'red' }} className={s.formGroup}>
              Wprowadź hasło!
            </div> : null }
            <div className={`${s.niceShadows} ${s.formGroup}`}>
              <button className={s.button} onClick={this.onClickValid} type={buttonType} style={{ fontWeight: '600', border: 'none', fontSize: '20px' }}>
                <span style={{ textTransform: 'uppercase' }}>Logowanie</span> standardowe
              </button>
            </div>
            <ModalAlert
              title={"Błędne dane!"}
              bodyText={"Nieprawidłowy użytkownik lub hasło."}
              show={this.state.didIlogedIn}
              name="errorModal"
              onHide={this.hideModal}
            />
          </form>
          <form method="post" action={process.env.LOGIN_ENDPOINT}>
            <button className={`${s.niceShadows} ${s.profilZau}`} type="submit" style={{ padding: '0', border: 'none', textDecoration: 'none', height: '46px', width: '100%' }} href={process.env.LOGIN_ENDPOINT}>
              <div className={s.formGroup} style={{ display: 'flex', width: '100%', height: '46px', justifyContent: 'space-around', alignItems: 'center', fontSize: '20px', color: 'white', fontWeight: '600' }}>
                <span className="col-xs-12" style={{ textTransform: 'uppercase' }}>Logowanie</span> przez
                <img className="col-xs-12" src={napisPZ} role="presentation" style={{ maxWidth: '100px' }} />
              </div>
            </button>
          </form>
        </div> :
        <GrayPanel title="Ładowanie okna logowania" bodyStyle={{ textAlign: 'center !important', marginTop: '100px', marginBottom: '100px'}}><img role="presentation" src={waiting} /></GrayPanel>
      }
      </div>
    );
  }
}

export default withStyles(s)(Login);



// WEBPACK FOOTER //
// src/routes/login/Login.js